<template>
  <div id="login-dialog" class="custom-modal">
    <HolaconLottie v-if="loading == 'created'" class="w-100" key="create-loading" />

    <div class="modal-body" v-else key="content-loading">
      <el-tabs v-model="activeName">
        <el-tab-pane :label="this.$t('accountInformation')" name="account">
          <div class="custom-info-card">
            <div class="custom-info-card-icon">
              <img src="/static/images/menuicons/shield.svg" alt />
            </div>

            <div class="custom-info-card-body">
              <template v-if="$i18n.locale == 'tr'">
                <p class="mb-0">Hesabınızı {{ $moment($store.getters.currentUser.createDate).format("DD MMMM YYYY HH:mm") }} tarihinde oluşturdunuz.</p>
                <!-- <p>Çıkış yapmak için <a href="javascript:;" @click="logout">tıklayınız.</a></p> -->
              </template>
              <template v-else>
                <p class="mb-0">You've created your account on {{ $moment($store.getters.currentUser.createDate).format("DD MMMM YYYY HH:mm") }}</p>
                <!-- <p><a href="javascript:;" @click="logout">Click here</a> to logout.</p> -->
              </template>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <el-radio-group v-model="$i18n.locale">
                <el-radio-button label="tr">{{ $t("event.variables.tr") }}</el-radio-button>
                <el-radio-button label="en">{{ $t("event.variables.en") }}</el-radio-button>
              </el-radio-group>
            </div>
          </div>

          <form>
            <div class="row justify-content-center">
              <div class="col-md-12" style=" margin: 0px; padding: 0px; display: flex; align-items: center; justify-content: center; flex-direction: column; ">
                <div class="form-group col-md-12 py-3 mb-1 d-flex justify-content-center" style="width: 200px">
                  <el-upload :onProgress="logoProgress" class="avatar-uploader profile-picture" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=profilePicture&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" :show-file-list="false" :on-success="logoSuccess">
                    <div class="avatar-wrapper">
                      <div v-if="form.image" :style="'background-image: url(' + form.image + ');background-size:cover;'" style=" width: 100%; height: 200px; background-size: contain; background-repeat: no-repeat; background-position: center;" class="avatar"></div>
                    </div>
                    <!-- <i v-else class="fas fa-plus avatar-uploader-icon"></i> -->
                    <div class="upload-tip-wrapper">
                      <el-button size="small" type="primary" circle icon="el-icon-upload"></el-button>
                      <div class="el-upload__tip" slot="tip">{{ $t("generic.picMsg") }}</div>
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-6">
                <label>{{ this.$t("name") }} :</label>
                <el-input v-model="form.firstName" :class="$inputError('firstName', validationErrors)"></el-input>
                <span class="error">{{ $errorMessage("firstName", validationErrors) }}</span>
              </div>

              <div class="form-group col-md-6">
                <label>{{ this.$t("surname") }} :</label>

                <el-input v-model="form.lastName" :class="$inputError('lastName', validationErrors)"></el-input>
                <span class="error">{{ $errorMessage("lastName", validationErrors) }}</span>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-12">
                <label>{{ this.$t("enums.inputTypes.mail") }} :</label>

                <el-input v-model="form.email" :class="$inputError('email', validationErrors)"></el-input>
                <span class="error">{{ $errorMessage("email", validationErrors) }}</span>
              </div>

              <div class="form-group col-md-12">
                <label>{{ this.$t("phone1") }} :</label>
                <vue-tel-input class="el-input__inner" placeholder="5555555555" mode="international" :enabledCountryCode="true" v-model="form.phoneNumber"></vue-tel-input>
                <span class="error">{{ $errorMessage("phoneNumber", validationErrors) }}</span>
              </div>

              

            </div>
          </form>
        </el-tab-pane>

        <!-- <el-tab-pane :label="this.$t('appSettings')" name="settings">
          <div class="custom-info-card">
            <div class="custom-info-card-icon">
              <img src="/static/images/menuicons/cog.svg" alt />
            </div>

            <div class="custom-info-card-body">
              <template v-if="$i18n.locale == 'tr'">
                <p class="mb-0">Bu bölüm güncellenmektedir. Çok yakında uygulama içi kullanıcı ayarları ve bildirim ayarları kullanıma sunulacak.</p>
              </template>
              <template v-else>
                <p class="mb-0">This section is being updated. In-app user settings and notification settings will be available very soon.</p>
              </template>
            </div>
          </div>
          
        </el-tab-pane> -->

        <el-tab-pane :label="this.$t('passSettings')" name="password">
          <div class="custom-info-card">
            <div class="custom-info-card-icon">
              <i class="fas fa-lock" style="margin-left:2px; color:#268ea6;"></i>
            </div>

            <div class="custom-info-card-body">
              {{ this.$t("accountInfo") }}
              <span v-if="$store.getters.currentUser.passwordUpdateDate == null">{{ this.$t("neverUpdated") }}</span>
              <template v-if="$i18n.locale == 'tr'">
                <p v-if="$store.getters.currentUser.passwordUpdateDate != null">Hesap şifrenizi {{ $moment($store.getters.currentUser.passwordUpdateDate).format("DD MMMM YYYY HH:mm") }} tarihinde güncellediniz.</p>
              </template>
              <template v-else>
                <p v-if="$store.getters.currentUser.passwordUpdateDate != null">You've updated your account password on {{ $moment($store.getters.currentUser.passwordUpdateDate).format("DD MMMM YYYY HH:mm") }}</p>
              </template>
            </div>
          </div>

          <form>
            <input autocomplete="false" name="hidden" type="text" style="display: none" />
            <div class="row">
              <div class="form-group col-md-12">
                <label>{{ this.$t("password") }} :</label>
                <el-input v-model="passwordForm.currentPassword" :class="$inputError('currentPassword', validationErrors2)"></el-input>
                <span class="error">{{ $errorMessage("currentPassword", validationErrors2) }}</span>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-6">
                <label>{{ this.$t("newPass") }} :</label>
                <el-input v-model="passwordForm.password" :class="$inputError('password', validationErrors2)"></el-input>
                <span class="error">{{ $errorMessage("password", validationErrors2) }}</span>
              </div>

              <div class="form-group col-md-6">
                <label>{{ this.$t("newPass_") }} :</label>
                <el-input v-model="passwordForm.passwordRetry" :class="$inputError('passwordRetry', validationErrors2)"></el-input>
                <span class="error">{{ $errorMessage("passwordRetry", validationErrors2) }}</span>
              </div>
            </div>
          </form>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("event.buttons.close") }}</el-button>
      </div>
      <div class="right-buttons">
        <el-button type="secondary" @click="logout" v-if="activeName == 'account'">
          <i class="fas fa-sign-out-alt" style="font-size: 16px;"></i>
          <span>{{ $t("event.buttons.logout") }}</span>
        </el-button>
        <el-button type="primary" @click="save" :loading="loading == 'save'" v-if="activeName == 'account'">{{ $t("event.buttons.save") }}</el-button>
        <el-button type="primary" @click="savePassword" :loading="loading == 'savePassword'" v-if="activeName == 'password'">{{ $t("event.buttons.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment/min/moment-with-locales";
import axios from "axios";
export default {
  name: "MyAccount",
  metaInfo: {
    title: "Account"
  },
  data() {
    return {
      form: JSON.parse(JSON.stringify(this.$store.getters.currentUser)),
      logoPercent: 0,
      axios,
      lang: localStorage.getItem("lang"),
      activeName: "account",
      validationErrors: [],
      validationErrors2: [],
      passwordForm: {
        currentPassword: null,
        password: null,
        passwordRetry: null
      },
      loading: false,
      timeout: null
    };
  },
  async created() {
    this.loading = "created";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      this.loading = false;
    }, 500);
  },
  methods: {
    save() {
      this.loading = "save";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("userUpdate", {
          ...this.form,
          phoneNumber: this.form.phoneNumber != null ? this.form.phoneNumber.replace(/[- .]/g, "") : null
        });
        this.validationErrors = res.data.validationErrors;
        this.loading = false;
      }, 500);
    },
    saveLanguage() {
      if (this.$i18n.locale == "tr") this.$message.success("Ayarlarınız başarıyla kaydedildi.");
      else this.$message.success("Your settings have been successfully saved.");
    },
    savePassword() {
      this.loading = "savePassword";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("userPasswordUpdate", {
          ...this.passwordForm
        });
        this.validationErrors2 = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.passwordForm = {
            currentPassword: null,
            password: null,
            passwordRetry: null
          };
        }
        this.loading = false;
      }, 500);
    },
    async logout() {
      this.$nextTick(() => {
        localStorage.removeItem("token");
        this.$store.state.user.user = null;
        this.$store.state.user.token = null;
      });
      this.$nextTick(() => {
        this.$router.push({ name: "login" }).catch(() => {});
      });
    },
    logoProgress(event) {
      this.logoPercent = event.percent;
    },
    logoSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data.item.url;
      }
    }
  },
  watch: {
    "$i18n.locale": async function(newVal, oldVal) {
      moment.locale(newVal);
      localStorage.setItem("lang", newVal);
      axios.defaults.headers["language"] = newVal;
      var res = await axios.post("/Account/UpdateLanguageCode", {});
      this.$root.$i18n.locale = newVal;
      if (!res.data.alert.hasError) {
        this.$emit("close-dialog");
        window.location.reload();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/MyAccount.vue